import { QueryClient } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { getSession } from 'next-auth/react';

import LessonsPage from '../../../components/dynamicPages/LessonsPage';
import NoAccess from '../../../providers/NoAccess';
import { detectAndBestEffortSetLanguage } from '../../../utils/localisationUtils';
import { dehydrateReactQueryPrefetchedInfiniteQuery } from '../../../utils/react-query-utils';
import { provisionFlags } from '../../../utils/ServerSideFeatureFlagUtils';

export const getServerSideProps: GetServerSideProps = async context => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=300, stale-while-revalidate=3600',
  );
  const session = await getSession({ req: context.req });
  if (!session) {
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  } else {
    const queryClient = new QueryClient();
    return {
      props: {
        ...(await provisionFlags(context, queryClient, session)),
        dehydratedState: dehydrateReactQueryPrefetchedInfiniteQuery(queryClient),
        ...(await detectAndBestEffortSetLanguage(context)),
        session,
      },
    };
  }
};
const MyLessonPage = () => {
  return (
    <NoAccess>
      <LessonsPage />
    </NoAccess>
  );
};

export default MyLessonPage;
